import React, { Component } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import { connect } from 'react-redux';
import actions from '../../redux/actions';
import actionTypes from '../../redux/actionTypes';
import Heading from '../Heading';
import NavButtons from '../NavButtons';

class CreateAgreementWorkForHire extends Component {
  constructor() {
    super();
    this.state = { name: '' };
  }

  componentWillMount() {
    if (this.props.agreement) {
      this.setState({ name: this.props.agreement.name });
    }
    if (this.props.team) {
      this.props.loadMembers(this.props.team.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { status } = nextProps;

    if (this.props.status === actionTypes.AGREEMENT_CREATE_REQUEST) {
      if (status === actionTypes.AGREEMENT_CREATE_SUCCESS) {
        this.props.router.push('/create/agreement-terms');
      } else if (status === actionTypes.AGREEMENT_CREATE_ERROR) {
        this.props.alert(
          'error',
          'Oops! Something went wrong. Please try again. If this error persists, please contact us.'
        );
      }
    }
  }

  handleName(e) {
    this.setState({ name: e.target.value });
  }

  handleKeydown(e) {
    if (e.keyCode === 13) {
      this.handleNext();
    }
  }

  handleNext() {
    const { profile, team, members } = this.props;
    const { name } = this.state;

    this.props.hideAlert();

    if (name === '') {
      this.props.alert('error', 'Please name this agreement.');
      return false;
    }

    if (members) {
      const workOwnerships = members.map((member) => ({
        user: member.user,
        role_ids: member.role_ids,
        ownership_type: member.ownership ? member.ownership.ownership_type : 1,
        percentage: member.ownership ? member.ownership.percentage : '0.00',
      }));

      this.props.setWorkOwnerships(workOwnerships);
    }

    this.props.selectAgreement({
      name,
      team: team.id,
      user: profile.id,
      type: 'workforhire',
    });

    this.props.router.push(
      '/create/agreement-terms/work-for-hire/work-for-hire'
    );
  }

  handlePrev() {
    this.props.router.push('/create/select-agreement');
  }

  render() {
    return (
      <div className="create-agreement">
        <Heading text="New Agreement" />
        <div className="content">
          <form>
            <FormGroup controlId="agreement-name">
              <FormControl
                ref="agreementName"
                type="text"
                className="agreement-name-input"
                value={this.state.name}
                placeholder="Agreement name"
                onChange={(e) => this.handleName(e)}
                onKeyDown={(e) => this.handleKeydown(e)}
              />
            </FormGroup>
          </form>
        </div>
        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handlePrev()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.create.fields,
  profile: state.profile,
  team: state.teams.selectedTeam,
  members: state.users.members,
  status: state.agreements.status,
  error: state.agreements.error,
  agreement: state.agreements.selectedAgreement,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  loadMembers: (teamId) => {
    dispatch(actions.getTeamMembers(teamId));
  },
  updateOwnership: (ownership) => {
    dispatch(actions.updateMemberOwnership(ownership));
  },
  selectAgreement: (data) => {
    dispatch(actions.selectAgreement(data));
  },
  setWorkOwnerships: (workOwnerships) => {
    dispatch(actions.setWorkOwnerships(workOwnerships));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAgreementWorkForHire);



// WEBPACK FOOTER //
// src/components/Agreements/CreateAgreementWorkForHire.jsx